<template>
    <div>
        <ProductRowBig :list="params.list" :limit="params.limit"/>
    </div>
</template>

<script>
import ProductRowBig from "./ProductRowBig.vue";

export default {
    components: { ProductRowBig },

    props: {
        params: {
            type: [Object, Array]
        }
    },
}
</script>

<style>

</style>